'use strict';

import { API_BASE } from './constants.js';
import { apiFetch } from './api.js';

export function registerSW() {
  if (!('serviceWorker' in navigator)) return;
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(err => {
      console.warn('Service worker registration failed:', err);
    });
  });

  // No custom "Add to Home Screen" banner — we leave beforeinstallprompt alone
  // so the browser shows its own native install affordance (address-bar icon /
  // menu entry) instead.
}

// Called after login. Requests notification permission and subscribes if
// the server has VAPID configured.
export async function setupPushNotifications() {
  if (!('Notification' in window) || !('PushManager' in window)) return;
  if (!navigator.serviceWorker) return;

  let vapidKey;
  try {
    const resp = await fetch(API_BASE + '/push/vapid-public-key');
    if (!resp.ok) return; // push not configured on server
    const data = await resp.json();
    vapidKey = data.data && data.data.public_key;
    if (!vapidKey) return;
  } catch { return; }

  if (Notification.permission === 'denied') return;
  if (Notification.permission !== 'granted') {
    const perm = await Notification.requestPermission();
    if (perm !== 'granted') return;
  }

  try {
    const reg = await navigator.serviceWorker.ready;
    const sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(vapidKey),
    });
    const json = sub.toJSON();
    await apiFetch('POST', '/push/subscribe', {
      endpoint: json.endpoint,
      p256dh:   json.keys.p256dh,
      auth:     json.keys.auth,
    });
  } catch (err) {
    console.warn('Push subscription failed:', err);
  }
}

// Convert a base64url string to a Uint8Array (required by pushManager.subscribe).
export function urlBase64ToUint8Array(base64url) {
  const padding = '='.repeat((4 - base64url.length % 4) % 4);
  const base64 = (base64url + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = atob(base64);
  const output = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) output[i] = raw.charCodeAt(i);
  return output;
}
